import { render, staticRenderFns } from "./AIGapList.vue?vue&type=template&id=a069864e"
import script from "./AIGapList.vue?vue&type=script&lang=js"
export * from "./AIGapList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports